import axios from 'axios';

const performClientHandshake = async (domain = "designprintnyc.com") => {
    try {
        // console.log('Initiating client handshake...');
        const handshakePayload = {
            payload: {
                agent_iam: "admin-web-app",
                domain: "designprintnyc.com"
            }
        };
        // console.log('Handshake payload:', handshakePayload);

        const tokenAlreadyExists = localStorage.getItem('handshake_token');
        if (tokenAlreadyExists) {
            // console.log('Handshake token already exists in localStorage:', tokenAlreadyExists);
            return tokenAlreadyExists;
        }

        const response = await axios.post(
            `${process.env.REACT_APP_URL__identity_microservices}/auth/client-handshake`,
            handshakePayload
        );

        const handshakeToken = response.headers['x-handshake-token'];
        // console.log('Handshake Response:', response);
        // console.log('Handshake Token:', handshakeToken);

        if (handshakeToken) {
            localStorage.setItem('handshake_token', handshakeToken);
            // console.log('Handshake token stored in localStorage:', localStorage.getItem('handshake_token'));
            return handshakeToken;
        } else {
            console.error('No handshake token received');
            return null;
        }
    } catch (error) {
        console.error('Client handshake failed:', error);
        return null;
    }
};

export default performClientHandshake;